import { PendingIssueListView } from '@euler/app/flows/common/components/PendingIssueListView';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { PendingIssue } from '@euler/model/report';
import { StatusBar } from 'expo-status-bar';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

export const HistoricalServiceInfoPendingIssuesScreen = wrapNavigatorScreen(
  ({
    pendingIssues,
    bottomSheet,
  }: {
    pendingIssues: PendingIssue[];
    bottomSheet?: boolean;
  }) => {
    const { rpx } = useResponsiveContext();
    const { bottom } = useSafeAreaInsets();

    return (
      <>
        {!bottomSheet && <StatusBar style="dark" />}
        <PendingIssueListView
          pendingIssues={pendingIssues}
          bottomSheet={bottomSheet}
          contentContainerStyle={{
            paddingBottom: bottom + rpx(15),
          }}
        />
      </>
    );
  },
  {
    headerShown: true,
    title: '遗留问题',
  },
);
